import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ProtectedRoute } from "@/components/DashboardShell";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Pro from "@/pages/Pro";
import InstallFunnel from "@/pages/InstallFunnel";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Conseils from "@/pages/Conseils";
import ConseilPost from "@/pages/ConseilPost";
import Login from "@/pages/Login";
import RegisterClient from "@/pages/RegisterClient";
import RegisterPro from "@/pages/RegisterPro";
import Legal from "@/pages/Legal";
import AuthCallback from "@/pages/AuthCallback";
import ClientDashboard from "@/pages/ClientDashboard";
import IntervenantDashboard from "@/pages/IntervenantDashboard";
import PoseurDashboard from "@/pages/PoseurDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/pro" element={<Pro />} />
      <Route path="/installation" element={<InstallFunnel />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/conseils" element={<Conseils />} />
      <Route path="/conseils/:slug" element={<ConseilPost />} />
      <Route path="/connexion" element={<Login />} />
      <Route path="/inscription" element={<RegisterClient />} />
      <Route path="/rejoindre" element={<RegisterPro />} />
      <Route path="/cgv" element={<Legal page="cgv" />} />
      <Route path="/mentions-legales" element={<Legal page="mentions-legales" />} />
      <Route path="/confidentialite" element={<Legal page="confidentialite" />} />
      <Route path="/paiement/succes" element={<PaymentSuccess />} />
      <Route path="/paiement/annule" element={<PaymentCancel />} />
      <Route path="/espace-client" element={<ProtectedRoute roles={["client"]}><ClientDashboard /></ProtectedRoute>} />
      <Route path="/espace-intervenant" element={<ProtectedRoute roles={["intervenant"]}><IntervenantDashboard /></ProtectedRoute>} />
      <Route path="/espace-poseur" element={<ProtectedRoute roles={["poseur"]}><PoseurDashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  );
}
